<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields"
      :permission="permission" :buttons="buttons" :searchs="searchs" :limitHeight="true" ref="table"></common-table>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import request from "@/utils/axios";
import message from "@/utils/message";

export default {
  name: 'DouYinVideo',
  components: { CommonTable },
  data() {
    return {
      searchs: [/*{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }*/{
          name: 'advertiserId',
          placeholder: '广告主',
          type: 'select',
      selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
          valueKey: 'advertiserId',
          selectData: [],
        }, {
          name: 'aweMeId',
          placeholder: '抖音名称',
          type: 'select',
          selectUrl: '/launchTheProduct/getAllIDInfo',
          selectData: [],
        }, {
          name: 'productId',
          placeholder: '商品ID',
          type: 'input'
        }],
      permission: {
        add: 'douYinVideo:add',
        update: 'douYinVideo:update',
        delete: 'douYinVideo:delete',
        deleteBatch: 'douYinVideo:deleteBatch'
      },
      url: {
        get: '/douYinVideo/listByCondition',
        add: '/douYinVideo/add',
        update: '/douYinVideo/update',
        delete: '/douYinVideo/delete',
        delete_batch: '/douYinVideo/deleteBatch',
        status: '/douYinVideo/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',  // 字段名
        label: 'agentId',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'advertiserId',  // 字段名
        label: '广告主ID',  // 字段显示名称
        sort: false,  // 是否排序
      selectUrl: '/oceanEngineAdvertiser/optionsByCondition',
        valueKey: 'advertiserId',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'aweMeId',  // 字段名
        label: '抖音号',  // 字段显示名称
        sort: false,  // 是否排序
        selectUrl: '/launchTheProduct/getAllIDInfo',
        selectData: [],
        show: {
          type: 'select',
        },
      }, {
        field: 'productId',  // 字段名
        label: '商品ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'aweMeItemId',  // 字段名
        label: '抖音短视频ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'commentCnt',  // 字段名
        label: '评论数',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'duration',  // 字段名
        label: 'duration',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'height',  // 字段名
        label: 'height',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'isRecommend',  // 字段名
        label: '是否推荐',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'likeCnt',  // 字段名
        label: 'likeCnt',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'materialId',  // 字段名
        label: '素材id',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'shareCnt',  // 字段名
        label: 'shareCnt',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'title',  // 字段名
        label: '抖音中的视频标题',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'url',  // 字段名
        label: '视频地址',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'videoCoverUrl',  // 字段名
        label: '视频封面图片url',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
        img: true
      }, {
        field: 'videoId',  // 字段名
        label: '视频ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'viewCnt',  // 字段名
        label: 'viewCnt',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'width',  // 字段名
        label: 'width',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'isAiCreate',  // 字段名
        label: '是否AI生成',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              { required: true, message: 'agentId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'advertiserId',  // 字段名
            label: 'advertiserId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入advertiserId',
            rules: [
              { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'aweMeId',  // 字段名
            label: 'aweMeId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入aweMeId',
            rules: [
              { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'productId',  // 字段名
            label: 'productId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入productId',
            rules: [
              { required: true, message: 'productId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'aweMeItemId',  // 字段名
            label: 'aweMeItemId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入aweMeItemId',
            rules: [
              { required: true, message: 'aweMeItemId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'commentCnt',  // 字段名
            label: 'commentCnt',  // 字段显示名称
            type: 'input',
            placeholder: '请输入commentCnt',
            rules: [
              { required: true, message: 'commentCnt不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'duration',  // 字段名
            label: 'duration',  // 字段显示名称
            type: 'input',
            placeholder: '请输入duration',
            rules: [
              { required: true, message: 'duration不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'height',  // 字段名
            label: 'height',  // 字段显示名称
            type: 'input',
            placeholder: '请输入height',
            rules: [
              { required: true, message: 'height不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'isAiCreate',  // 字段名
            label: 'isAiCreate',  // 字段显示名称
            type: 'input',
            placeholder: '请输入isAiCreate',
            rules: [
              { required: true, message: 'isAiCreate不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'isRecommend',  // 字段名
            label: 'isRecommend',  // 字段显示名称
            type: 'input',
            placeholder: '请输入isRecommend',
            rules: [
              { required: true, message: 'isRecommend不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'likeCnt',  // 字段名
            label: 'likeCnt',  // 字段显示名称
            type: 'input',
            placeholder: '请输入likeCnt',
            rules: [
              { required: true, message: 'likeCnt不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'materialId',  // 字段名
            label: 'materialId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入materialId',
            rules: [
              { required: true, message: 'materialId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'shareCnt',  // 字段名
            label: 'shareCnt',  // 字段显示名称
            type: 'input',
            placeholder: '请输入shareCnt',
            rules: [
              { required: true, message: 'shareCnt不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'title',  // 字段名
            label: 'title',  // 字段显示名称
            type: 'input',
            placeholder: '请输入title',
            rules: [
              { required: true, message: 'title不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'url',  // 字段名
            label: 'url',  // 字段显示名称
            type: 'input',
            placeholder: '请输入url',
            rules: [
              { required: true, message: 'url不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'videoCoverUrl',  // 字段名
            label: 'videoCoverUrl',  // 字段显示名称
            type: 'input',
            placeholder: '请输入videoCoverUrl',
            rules: [
              { required: true, message: 'videoCoverUrl不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'videoId',  // 字段名
            label: 'videoId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入videoId',
            rules: [
              { required: true, message: 'videoId不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'viewCnt',  // 字段名
            label: 'viewCnt',  // 字段显示名称
            type: 'input',
            placeholder: '请输入viewCnt',
            rules: [
              { required: true, message: 'viewCnt不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          }, {
            field: 'width',  // 字段名
            label: 'width',  // 字段显示名称
            type: 'input',
            placeholder: '请输入width',
            rules: [
              { required: true, message: 'width不能为空', trigger: 'blur' }
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: [],
      buttons: [{
        icon: 'el-icon-circle-check',
        type: 'success',
        text: '批量更新',
        permission: 'douYinVideo:updateInfo',
        click: () => {
          request.get({
            url: '/douYinVideo/getDouYinVideo',
            success: (data) => {
              if (data.code == 0) {
                message.success("批量更新成功");
                this.$refs.table.getData()
              }
            }
          });
        }
      }]
    }
  }
}
</script>

<style scoped></style>
